<template>
    <Modal :id="id" title="Change Brand">
        <div slot="body" class="modal-body modal-form">
            <div class="row">
                <div class="col-12">
                    <p>
                        <strong>{{ enrollment.user.name }}</strong>
                        <span v-if="enrollment.user.hvac_id">
                            ({{ enrollment.user.hvac_id }})
                        </span>
                    </p>
                    <div class="form-group">
                        <Field
                            label="Brand"
                            type="select"
                            name="replacement"
                            :options="brands"
                            v-model="selected"
                            :hide-select-empty-option="true"
                        />
                    </div>
                </div>
            </div>
        </div>
        <div slot="footer" class="modal-footer">
            <a class="btn btn-success" href="#" @click.prevent="submit()">Submit</a>
            <a class="btn btn-info" href="#" @click.prevent="close()">Cancel</a>
        </div>
    </Modal>
</template>

<script>
import ModalMixin from "mixins/Modal";

export default {
    mixins: [ModalMixin],

    data() {
        return {
            id: "brand-replace-modal",
            event: null,
            enrollment: null,
            brands: [],
            selected: null,
        };
    },

    methods: {
        load() {
            const url = this.route("training.events.enrollments.brand-replacements", {
                enrollment: this.enrollment.id,
            });

            this.axios.get(url).then((response) => {
                this.brands = response.data;
            });
        },
        submit() {
            if (!this.selected) {
                alert("Please select a replacement brand before continuing.");
                return;
            }

            const url = this.route("training.events.enrollments.replace-brand", {
                enrollment: this.enrollment.id,
            });

            this.axios.post(url, {brand_id: this.selected}).then(() => {
                this.resolve();
            });
        },
    },

    created() {
        this.event = _.cloneDeep(this.options.event);
        this.enrollment = _.cloneDeep(this.options.enrollment);
        this.selected = this.enrollment.brand_id;
        this.load();
    },
};
</script>
